// extracted by mini-css-extract-plugin
export default {"root":"mnGXltJabkzcFO6P3gAn"};